var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 73.999,
    viewBox: "0 0 74 73.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5bc2e7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.912,83.606h-9.054a5.656,5.656,0,1,0,0,11.312h9.054a5.656,5.656,0,0,0,0-11.312Z",
    transform: "translate(-89.568 -52.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.366,89.262a5.656,5.656,0,0,0-5.656-5.656H5.656a5.656,5.656,0,1,0,0,11.312H14.71A5.656,5.656,0,0,0,20.366,89.262Z",
    transform: "translate(0 -52.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88.929,143.2a5.656,5.656,0,0,0-5.656,5.656v9.054a5.656,5.656,0,0,0,11.312,0v-9.054A5.656,5.656,0,0,0,88.929,143.2Z",
    transform: "translate(-52.054 -89.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88.929,0a5.656,5.656,0,0,0-5.656,5.656v9.053a5.656,5.656,0,0,0,11.312,0V5.657A5.656,5.656,0,0,0,88.929,0Z",
    transform: "translate(-52.054 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M135.4,127.4a5.656,5.656,0,0,0-8,8l6.4,6.4a5.656,5.656,0,0,0,8-8Z",
    transform: "translate(-78.694 -78.695)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M34.144,26.144a5.656,5.656,0,1,0-8,8l6.4,6.4a5.656,5.656,0,0,0,8-8Z",
    transform: "translate(-15.255 -15.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.545,127.4l-6.4,6.4a5.656,5.656,0,0,0,8,8l6.4-6.4a5.656,5.656,0,0,0-8-8Z",
    transform: "translate(-15.254 -78.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M131.4,42.2a5.637,5.637,0,0,0,4-1.657l6.4-6.4a5.656,5.656,0,1,0-8-8l-6.4,6.4a5.656,5.656,0,0,0,4,9.656Z",
    transform: "translate(-78.693 -15.253)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.59740ad9d2bc6f8e024f3274d91e716d.svg";
export { ForwardRef as ReactComponent };